import { useAppStore } from '@/hud-bridge/store'
import { detectTouchPreferred } from '@/input/InputManager'

export function BriefingScreen() {
  const setScreen = useAppStore((s) => s.setScreen)
  const patchSettings = useAppStore((s) => s.patchSettings)
  const settings = useAppStore((s) => s.settings)
  const touch = detectTouchPreferred(settings.preferTouch)

  return (
    <div className="screen">
      <div className="menu-enter panel" style={{ marginTop: '10vh' }}>
        <h1 className="h1">Управление</h1>
        {touch ? (
          <ul className="muted" style={{ lineHeight: 1.6, paddingLeft: 18 }}>
            <li>Левый стик — движение (скорость от отклонения)</li>
            <li>Свайп по экрану — обзор</li>
            <li>Шаг на клетку — вскрытие (число на тайле)</li>
            <li>Check — проверить клетку под прицелом без шага; мина = поражение</li>
            <li>Defuse — удерживай на прицеле (не отпускай — это не выделение текста)</li>
            <li>ACT / DEF — сколько мин ещё опасно / уже снято (в Clear)</li>
            <li>Cam — FPS / TPP</li>
            <li>Шаг на мину — поражение; по обезвреженной ходить можно</li>
          </ul>
        ) : (
          <ul className="muted" style={{ lineHeight: 1.6, paddingLeft: 18 }}>
            <li>WASD — движение</li>
            <li>Мышь — обзор (pointer lock)</li>
            <li>Шаг на клетку — вскрытие (число на тайле)</li>
            <li>F — Check: вскрыть клетку под прицелом без шага; мина = поражение</li>
            <li>ЛКМ/ПКМ hold — Defuse под прицелом</li>
            <li>ACT / DEF — ещё опасные / уже разминированные (Clear)</li>
            <li>C — FPS / TPP</li>
            <li>Esc — пауза</li>
            <li>Шаг на мину — поражение; по обезвреженной ходить можно</li>
          </ul>
        )}

        <label className="check">
          <input
            type="checkbox"
            checked={settings.hideBriefing}
            onChange={(e) => patchSettings({ hideBriefing: e.target.checked })}
          />
          Больше не показывать
        </label>

        <div className="btn-row">
          <button type="button" className="btn btn-primary" onClick={() => setScreen('loading')}>
            В бой
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setScreen('map')}>
            Назад
          </button>
        </div>
      </div>
    </div>
  )
}
